import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Mail, ArrowRight, Check, X } from 'lucide-react';
import './Newsletter.css';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');
    setError('');
    
    try {
      const response = await fetch('/api/newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      if (response.ok) {
        setMessage('Thank you for subscribing!');
        setEmail('');
      } else {
        const data = await response.json();
        setError(data.message || 'Subscription failed. Please try again.');
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
    }
    
    setIsSubmitting(false);
  };

  return (
    <section className="apple-newsletter">
     

      <div className="apple-newsletter-container">
        <div className="apple-newsletter-content">
          {/* Icon */}
          <div className="apple-newsletter-icon">
            <Mail strokeWidth={1.5} />
          </div>

          {/* Content */}
          <h2 className="apple-newsletter-title">
            Stay in the loop
          </h2>
          <p className="apple-newsletter-description">
            Get the latest news, updates, and insights delivered directly to your inbox. 
            Join thousands of subscribers who trust us to keep them informed.
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="apple-newsletter-form">
            <div className="apple-newsletter-input-container">
              <input
                type="email"
                placeholder="Enter your email address"
                className="apple-newsletter-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isSubmitting}
              />
              <button 
                type="submit" 
                className="apple-newsletter-button" 
                disabled={isSubmitting || !email.trim()}
              >
                {isSubmitting ? (
                  <div className="apple-newsletter-spinner" />
                ) : (
                  <>
                    Subscribe
                    <ArrowRight className="apple-newsletter-arrow" />
                  </>
                )}
              </button>
            </div>
          </form>

          {/* Messages */}
          {message && (
            <div className="apple-newsletter-message apple-newsletter-success">
              <Check className="apple-newsletter-message-icon" />
              <span>{message}</span>
            </div>
          )}
          
          {error && (
            <div className="apple-newsletter-message apple-newsletter-error">
              <X className="apple-newsletter-message-icon" />
              <span>{error}</span>
            </div>
          )}

          {/* Privacy Note */}
          <p className="apple-newsletter-privacy">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;